import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'
import plantao from './plantao'

export default baseUrl => {

    baseUrl = `${baseUrl}/pronto-atendimento`

    const headers = { responseType: "arraybuffer" }

    return {
        plantao: plantao(baseUrl),
        exportClassificacaoRisco(queryParms) {

            return repository.get(`${baseUrl}/export-classificacao-risco?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportQuantitativoProducao(queryParms) {

            return repository.get(`${baseUrl}/export-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportAtendimento(params) {

            return repository.post(`${baseUrl}/export-atendimento`, params, headers)
        },
        exportProducaoMedico(queryParms) {

            return repository.get(`${baseUrl}/export-producao-medico?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportDocumentoNaoAssinado(queryParms) {

            return repository.get(`${baseUrl}/export-documento-nao-assinado?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportExameImagem(queryParms) {

            return repository.get(`${baseUrl}/export-exame-imagem?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportRelatorioTempoAtendimento(queryParms) {

            return repository.get(`${baseUrl}/export-relatorio-tempo-atendimento?${urlUtil.serialize(queryParms)}`, headers)
        }
    }
}
